import { internalApi } from '../../../../internal-api';

export const getCptsByCodes = async (
  codes: string[],
): Promise<{ code: string; description: string }[]> => {
  return await internalApi.orderAssistBff.getCptsByCodes({ codes });
};
